import { render, staticRenderFns } from "./ImageSection.vue?vue&type=template&id=2c2b46d2&scoped=true&lang=pug&"
import script from "./ImageSection.vue?vue&type=script&lang=js&"
export * from "./ImageSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageSection.vue?vue&type=style&index=0&id=2c2b46d2&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b46d2",
  null
  
)

export default component.exports